import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface ClientSidebarLink {
    name: string
    url: string
}

export default (axios: AxiosInstance = baseAxios): { updateClientSidebarLinks: (links: ClientSidebarLink[]) => Promise<void>; } => ({
    updateClientSidebarLinks: async (links: ClientSidebarLink[]): Promise<void> => {
        await axios.post('/api/staff/settings/client-sidebar-links', { links });
    },
});
